import React from "react";

const FooterCredit = () => {
  return (
    <div className="footer-credit">
      <p>&copy; {2024} Mahesh Chavan . All Rights Reserved.</p>
    </div>
  );
};

export default FooterCredit;
